import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from '../Sidebar';
import MyActions from './MyActions';
import AllActions from './AllActions';

const ActionsLayout = ({ onLogout }) => {
  return (
    <div className='d-flex w-100 overflow-hidden'>
      <div className='asidebar'>
        <Sidebar />
      </div>
      <div className='main-content' style={{ flex: 1, overflow: 'auto', padding: '20px' }}>
        <Routes>
          <Route index element={<Navigate to="/actions/all-actions" replace />} />
          <Route path="my-actions" element={<MyActions onLogout={onLogout} />} />
          <Route path="all-actions" element={<AllActions onLogout={onLogout} />} />
          <Route path="*" element={<Navigate to="/actions/all-actions" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default ActionsLayout;

